const mutations = {
	SET_GROUPS (state, data) {
		state.list = data;
	},
	SET_SMS_LIST (state, data) {
		state.smsLists = data
	},
	SET_LOADING (state, data) {
		state.loading = data
	},
	SET_SMS_LIST_TO_EDIT (state, data) {
		const smsListInfo = JSON.parse(JSON.stringify(data))
		state.listToEdit = {
		  ...state.listToEdit,
		  ...smsListInfo
		}
	  },
	  UNSET_SMSLIST_TO_EDIT (state, data) {
		state.listToEdit = {
			group_name: '',
			id_push_moe: '',
			is_active: null,
			updated_at: '',
		}
	},
	SET_SMSLIST_FILTER (state, data) {
		state.group_name = data
	  },
}		

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/messageForm/mutations.js